import { lt, showSuccessAlert } from '@mews/framework';
import { useDeleteConfirmationDialog } from '@mews-commander/ui';
import { useRepositoryMutation } from '@mews-commander/data-access';

interface Params {
    rateName: string;
    rateId: string;
    onSuccess?: () => void;
}
export const useDeleteRateDialog = ({ rateName, rateId, onSuccess }: Params) => {
    const { mutateAsync, isPending } = useRepositoryMutation('rates', 'delete', {
        invalidateQueries: { rates: ['getOverviewEntries', 'getAll', 'getDetail'] },
        onSuccess: () => {
            showSuccessAlert({ title: lt('DeleteSuccessMessage', { entity: rateName }) });
            onSuccess?.();
        },
    });

    const deleteAction = async () => mutateAsync({ rateId });

    const { confirmationDialog, openConfirmationDialog } = useDeleteConfirmationDialog({
        deleteAction,
        renderContent: () => lt('DeleteHint'),
        title: lt('DeleteConfirmation', { entity: rateName }),
        loading: isPending,
    });

    return { confirmationDialog, openConfirmationDialog };
};
